import React, { useEffect } from "react";
import UniqueCode from './UniqueCode';
import Training from './Training';
import Traineedetails from './Traineedetails';
import Certificate from './Certificate';
import Quiz from './Quiz';
import getBrowserFingerprint from 'get-browser-fingerprint';
import FeedbackSurvey from "./FeedbackSurvey";
import { use } from "i18next";
import { Base64 } from 'js-base64';

const PAGE_CODES = {
    LANDING: 'A1',
    TRAINEE: 'A2',
    TRAINING: 'A3',
    QUIZ: 'A4',
    FEEDBACK: 'A5',
    CERTIFICATE: 'A6'
};

const Dashboard = ({page}) => {
    const fingerprint = getBrowserFingerprint();
    const aidVal = localStorage.getItem('AID');
    if(aidVal){
        page = Base64.decode(aidVal);
    }

    
   
    const pageName = (p) => {      
        switch(p) {  
            case fingerprint + PAGE_CODES.TRAINING:
                return "Training module page";
            case fingerprint + PAGE_CODES.TRAINEE:
                return "Trainee details form page";
            case fingerprint + PAGE_CODES.QUIZ:
                return "Quiz page";
            case fingerprint + PAGE_CODES.FEEDBACK:
                return "Feedback Survey page";
            default:
                return "Unique code landing page";
        }
    }

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "customEvent",
          eventCategory: "Page Change",
          eventAction: pageName(page),
          eventLabel: pageName(page),
        });
      }, [page]);

    return (
        <>
            {(() => {
                switch (page) {
                    case fingerprint + PAGE_CODES.LANDING: return (<UniqueCode/>)
                    case fingerprint + PAGE_CODES.TRAINEE: return (<Traineedetails />)
                    case fingerprint + PAGE_CODES.TRAINING: return (<Training/>)
                    case fingerprint + PAGE_CODES.QUIZ: return (<Quiz/>)  
                    case fingerprint + PAGE_CODES.FEEDBACK: return (<FeedbackSurvey/>)
                    case fingerprint + PAGE_CODES.CERTIFICATE: return (<Certificate />)
                    default: return (<UniqueCode/>)
                }
            })()}
        </>
    );
};
export default Dashboard